import clsx from 'clsx';
import React from 'react';

const Group = ({ name, children, isInline = true }) => {
  return (
    <fieldset
      role="radiogroup"
      aria-labelledby={name}
      className={clsx('grid gap-2', {
        'grid-cols-2': isInline,
        'grid-cols-1': !isInline,
      })}
    >
      {children}
    </fieldset>
  );
};

const Card = ({ value, name, checked, onChange, children, disabled, footer }) => {
  return (
    <label
      className={clsx(
        'relative block w-full cursor-pointer rounded-md border px-3 py-2 text-left text-sm font-medium transition-colors outline-none',
        'focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2',
        checked ? 'border-primary' : 'border-input hover:bg-accent/50',
        {
          'cursor-not-allowed opacity-50': disabled,
        },
      )}
    >
      <input
        type="radio"
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        className="sr-only"
      />

      <div className="flex-1 pr-6">{children}</div>

      <span
        className={clsx(
          'absolute right-2 top-2 flex size-4 items-center justify-center rounded-full border transition-colors',
          checked ? 'border-primary' : 'border-input',
        )}
      >
        {checked && <span className="size-2 rounded-full bg-primary" />}
      </span>

      {footer && (
        <div className="mt-3 flex items-center justify-between gap-3 border-t border-border pt-3">
          {footer}
        </div>
      )}
    </label>
  );
};

const Label = ({ children }) => {
  return <div className="font-medium">{children}</div>;
};

const LabelDescription = ({ children }) => {
  return <div className="text-xs font-normal text-muted-foreground">{children}</div>;
};

const RadioCard = {
  Group,
  Label,
  LabelDescription,
  Card,
};

export default RadioCard;
